import { render } from "./buy-success.vue?vue&type=template&id=195f726a&scoped=true"
import script from "./buy-success.vue?vue&type=script&lang=ts"
export * from "./buy-success.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-195f726a"

export default script